/**
 * Created by Mark on 20/04/2017.
 */
import React  from 'react';
import {Card , Row , Col} from 'react-bootstrap'
import Translation from '../store/internationalization-store.js';

export default class examActivity{
    constructor(data){
        this.data = data;
    }

    generateData(gameUid){
        var examData = this.data;
        var mainText = "";
        var questions = [];
        if (this.data == undefined) {
            return ["", []];
        }
        if (gameUid == 200) {
            mainText = this.formatMainText(examData.mainTranslations.text);
            questions = [];
            for (var i = 0; i < examData.examDataGames[200].length; i++) {
                //<data><question>Elle s'appelle Danielle.</question><true>true</true></data>
                var textData = examData.examDataGames[200][i].text_data;
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(textData,"text/xml");
                var text1 = xmlDoc.getElementsByTagName("question")[0].childNodes[0].nodeValue;
                var text2 = xmlDoc.getElementsByTagName("true")[0].childNodes[0].nodeValue;
                if (text2.toLowerCase() == "true") {
                    text2 = Translation.get(12267, "true");
                } else {
                    text2 = Translation.get(12268, "false");
                }
                questions.push(<Col md={12}><Card>
                        <Card.Body>
                            <Row >
                                <Col sm={{span: 10, offset: 0}}><Card.Text>{text1}</Card.Text></Col>
                                <Col sm={{span: 2, offset: 0}}><span className="float-right"> 
                                        {text2}</span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card><br/></Col>)
            }
        } else if (gameUid == 201) {
            mainText = this.formatMainText(examData.mainTranslations.text);
            questions = [];
            for (var i = 0; i < examData.examDataGames[201].length; i++) {
                //<data><question>Elle s'appelle Danielle.</question><true>true</true></data>
                var textData = examData.examDataGames[201][i].text_data;
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(textData,"text/xml");
                var text1 = xmlDoc.getElementsByTagName("question")[0].childNodes[0].nodeValue;
                var text2 = xmlDoc.getElementsByTagName("correct")[0].childNodes[0].nodeValue;
                questions.push(<Col md={12}><Card>
                        <Card.Body>
                            <Row >
                                <Col sm={{span: 10, offset: 0}}><Card.Text>{text1}</Card.Text></Col>
                                <Col sm={{span: 2, offset: 0}}><span className="float-right"> 
                                        {text2}</span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card><br/></Col>)
            }
        }  else if (gameUid == 202) {
            mainText = <audio controls>
                    <source src={"https://storage.languagenut.com/" + examData.mainTranslations.sound} type="audio/mpeg" />
                </audio>
            questions = [];
            for (var i = 0; i < examData.examDataGames[202].length; i++) {
                //<data><question>Elle s'appelle Danielle.</question><true>true</true></data>
                var textData = examData.examDataGames[202][i].text_data;
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(textData,"text/xml");
                var text1 = xmlDoc.getElementsByTagName("question")[0].childNodes[0].nodeValue;
                var text2 = xmlDoc.getElementsByTagName("true")[0].childNodes[0].nodeValue;
                if (text2.toLowerCase() == "true") {
                    text2 = Translation.get(12267, "true");
                } else {
                    text2 = Translation.get(12268, "false");
                }
                questions.push(<Col md={12}><Card>
                        <Card.Body>
                            <Row >
                                <Col sm={{span: 10, offset: 0}}><Card.Text>{text1}</Card.Text></Col>
                                <Col sm={{span: 2, offset: 0}}><span className="float-right"> 
                                        {text2}</span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card><br/></Col>)
            }
        } else if (gameUid == 203) { 

            mainText = this.formatMainText(examData.mainTranslations.text);
            questions = [];
            for (var i = 0; i < examData.examDataGames[203].length; i++) {
                //<data><question>Elle s'appelle Danielle.</question><true>true</true></data>
                var textData = examData.examDataGames[203][i].text_data;
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(textData,"text/xml");
                var text1 = xmlDoc.getElementsByTagName("removed")[0].childNodes[0].nodeValue;
                //var text2 = xmlDoc.getElementsByTagName("true")[0].childNodes[0].nodeValue;
                questions.push(<Col md={12}><Card>
                        <Card.Body>
                            <Row >
                            <Col sm={{span: 10, offset: 0}}><Card.Text>{text1}</Card.Text></Col>
                            </Row>
                        </Card.Body>
                    </Card><br/></Col>)
            }
        } else if (gameUid == 204) { 

            mainText = <audio controls>
                    <source src={"https://storage.languagenut.com/" + examData.mainTranslations.sound} type="audio/mpeg" />
                </audio>
            questions = [];
            for (var i = 0; i < examData.examDataGames[204].length; i++) {
                //<data><question>Elle s'appelle Danielle.</question><true>true</true></data>
                var textData = examData.examDataGames[204][i].text_data;
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(textData,"text/xml");
                var text1 = xmlDoc.getElementsByTagName("question")[0].childNodes[0].nodeValue;
                var text2 = xmlDoc.getElementsByTagName("correct")[0].childNodes[0].nodeValue;
                questions.push(<Col md={12}><Card>
                        <Card.Body>
                            <Row >
                                <Col sm={{span: 10, offset: 0}}><Card.Text>{text1}</Card.Text></Col>
                                <Col sm={{span: 2, offset: 0}}><span className="float-right"> 
                                        {text2}</span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card><br/></Col>)
            }
        } else if (gameUid == 205) { 

            mainText = <audio controls>
                    <source src={"https://storage.languagenut.com/" + examData.mainTranslations.sound} type="audio/mpeg" />
                </audio>
            questions = [];
            var textData = examData.examDataGames[205][0].text_data;
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(textData,"text/xml");
            var answersa = [];
            var answersb = [];
            var answersc = [];
            answersa.push(this.processNode(xmlDoc.getElementsByTagName("personA")[0]));
            answersa.push(this.processNode(xmlDoc.getElementsByTagName("personA")[1]));
            answersa.push(this.processNode(xmlDoc.getElementsByTagName("personA")[2]));
            answersa.push(this.processNode(xmlDoc.getElementsByTagName("personA")[3]));
            answersb.push(this.processNode(xmlDoc.getElementsByTagName("personB")[0]));
            answersb.push(this.processNode(xmlDoc.getElementsByTagName("personB")[1]));
            answersb.push(this.processNode(xmlDoc.getElementsByTagName("personB")[2]));
            answersb.push(this.processNode(xmlDoc.getElementsByTagName("personB")[3]));
            answersc.push(this.processNode(xmlDoc.getElementsByTagName("personC")[0]));
            answersc.push(this.processNode(xmlDoc.getElementsByTagName("personC")[1]));
            answersc.push(this.processNode(xmlDoc.getElementsByTagName("personC")[2]));
            answersc.push(this.processNode(xmlDoc.getElementsByTagName("personC")[3]));

            questions.push(<Col md={12}><Card>
                <Card.Body>
                    <Row >
                        <Col sm={{span: 4, offset: 0}}><Card.Text><b>{Translation.get(12132,'Person A')}</b></Card.Text></Col>
                        <Col sm={{span: 4, offset: 0}}><Card.Text><b>{Translation.get(12133,'Person B')}</b></Card.Text></Col>
                        <Col sm={{span: 4, offset: 0}}><Card.Text><b>{Translation.get(12134,'Person C')}</b></Card.Text></Col>
                    </Row>
                </Card.Body>
            </Card><br/></Col>)

            for (var i =0; i < 4; i++) {
                questions.push(<Col md={12}><Card>
                    <Card.Body>
                        <Row >
                            <Col sm={{span: 4, offset: 0}}><Card.Text>{answersa[i]}</Card.Text></Col>
                            <Col sm={{span: 4, offset: 0}}><Card.Text>{answersb[i]}</Card.Text></Col>
                            <Col sm={{span: 4, offset: 0}}><Card.Text>{answersc[i]}</Card.Text></Col>
                        </Row>
                    </Card.Body>
                </Card><br/></Col>)
            }
        } else if (gameUid == 206) { 
            questions = [];
            mainText = this.formatMainText(examData.examDataQuestion.text);
        } else if (gameUid == 207) { 
            questions = [];
            mainText = this.formatMainText(examData.examDataQuestion.text);
        }  else if (gameUid == 208) { 
            questions = [];
            mainText = <img src={"https://storage.languagenut.com/vocabs/"+examData.examDataTranslations.image}></img>
        }
        return [mainText, questions];
    }

    formatMainText(text) {
        text = text.replace(new RegExp(" ", 'g'), " "); //Replace none breaking whitespace with normal space.
        text = text.replace(new RegExp("<newline/>", 'g'), " \n\n");
        text = text.replace(new RegExp("<newline />", 'g'), " \n\n");
        text = text.replace(new RegExp('<newline />', 'g'), " \n\n");
        text = text.replace(new RegExp("\n\n ", 'g'), "\n\n");
        text = text.replace(new RegExp(" \n\n", 'g'), "\n\n");
        text = text.replace(new RegExp("’", 'g'), "'");
        return <Col md={12}><Card>
                    <Card.Body>
                        <Row >
                            <Col sm={{span: 12, offset: 0}}><Card.Text>
                            {text}</Card.Text></Col>
                        </Row>
                    </Card.Body>
                </Card><br/></Col>;
    }

    processNode = function (value) {
        if (value == undefined) {
            return "-";
        }

        if (value.childNodes[0] == undefined) {
            return "-";
        } 
        return value.childNodes[0].nodeValue;
    }

}